import Language from '@opsbase/lib-i18n/Language';
import en from './en.json';
export const nls = {
    [Language.ENGLISH]: en,
};
export default nls;
